import React from 'react'

class TaskSearch extends React.Component {
  constructor () {
    super()
    this.state = {
      show_reset_button: false
    }
  }

  handleSubmit (e) {
    e.preventDefault()
    if (this.refs.search.value) {
      $.ajax({
        url: '/timeline_items/search_items',
        method: 'GET',
        dataType: 'JSON',
        data: { q: this.refs.search.value },
        success: (filtered_tasks) => {
          this.props.handleOnSubmit(filtered_tasks)
        }
      })
    } else {
      this.props.handleOnEmptySearch()
    }
  }

  handleOnChange () {
    if (this.refs.search.value) {
      this.setState({ show_reset_button: true })
    } else {
      this.setState({ show_reset_button: false })
      this.props.handleOnEmptySearch()
    }
  }

  handleOnReset (e) {
    e.preventDefault()
    this.refs.search.value = ''
    this.setState({ show_reset_button: false })
    this.props.handleOnEmptySearch()
  }

  renderSearchButton () {
    if (this.state.show_reset_button) {
      return (
        <button
          onClick={(e) => this.handleOnReset(e)}
          className='close-icon'
          type='reset'
        />
      )
    }
  }

  render () {
    return (
      <form className='search-box' onSubmit={(e) => this.handleSubmit(e)}>
        <input
          type='search'
          ref='search'
          className='form-control input-bdr-rds search-task'
          onChange={() => this.handleOnChange()}
          name='search_value'
          placeholder='Search tasks'
        />
        {this.renderSearchButton()}
      </form>
    )
  }
}

export default TaskSearch;